import React, { Component } from 'react';
import PropTypes from 'prop-types';

import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';

export const BlockUiContext = React.createContext();

export default class BlockUiProvider extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			hideBackground: false,
			handleLoading: this.handleLoading,
		};
	}

	handleLoading = (blLoading, blHideBackground) =>
		this.setState({ loading: blLoading, hideBackground: blHideBackground });

	render() {
		return (
			<BlockUiContext.Provider value={this.state}>
				<BlockUi
					tag="div"
					blocking={this.state.loading}
					loader={<img src="/img/loading.gif" alt="" />}
					renderChildren={true}
					className={`h-100 ${this.state.hideBackground ? 'hide-background' : ''}`}>
					{this.props.children}
				</BlockUi>
			</BlockUiContext.Provider>
		);
	}
}

BlockUiProvider.propTypes = {
	children: PropTypes.node.isRequired,
};
